import { useMutation } from "@tanstack/react-query";
import { apiPost } from "@/lib/api/client";
import { useAuthStore, type AuthUser } from "@/lib/auth/store";

interface LoginBody {
  email: string;
  password: string;
}

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: AuthUser;
}

export function useLogin() {
  const setSession = useAuthStore((s) => s.setSession);

  return useMutation({
    mutationFn: (body: LoginBody) =>
      apiPost<LoginResponse, LoginBody>("/v1/auth/login", body),
    onSuccess: (data) => {
      setSession({
        accessToken: data.accessToken,
        refreshToken: data.refreshToken,
        user: data.user,
      });
    },
  });
}
